var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.26562 15.4922H10.2344C11.2037 15.4922 11.9922 14.7037 11.9922 13.7344V5.76563C11.9922 4.79627 11.2037 4.00781 10.2344 4.00781H2.26562C1.29626 4.00781 0.507812 4.79627 0.507812 5.76563V13.7344C0.507812 14.7037 1.29626 15.4922 2.26562 15.4922ZM10.2344 5.17969C10.5575 5.17969 10.8203 5.44254 10.8203 5.76563V13.7344C10.8203 14.0575 10.5575 14.3203 10.2344 14.3203H2.26562C1.94253 14.3203 1.67969 14.0575 1.67969 13.7344V5.76563C1.67969 5.44254 1.94253 5.17969 2.26562 5.17969H10.2344ZM13.1641 10.8047H13.75C14.0731 10.8047 14.3359 10.5418 14.3359 10.2188V2.25C14.3359 1.92691 14.0731 1.66406 13.75 1.66406H5.78125C5.45816 1.66406 5.19531 1.92691 5.19531 2.25V2.80664H4.02344V2.25C4.02344 1.28064 4.81189 0.492188 5.78125 0.492188H13.75C14.7194 0.492188 15.5078 1.28064 15.5078 2.25V10.2188C15.5078 11.1881 14.7194 11.9766 13.75 11.9766H13.1641V10.8047Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.dc4e450be7e6c55c3dc2eb5ba2b66f1d.svg";
export { ForwardRef as ReactComponent };